<div class="login-page">
	<p-toast position="top-center" />

	<div
		class="tictac-login-form"
		animate.enter="slide-fade-down"
	>
		<img
			alt="Login Headline"
			ngSrc="assets/img/login-headline.svg"
			priority
			height="63"
			width="238"
		/>

		<ng-content />
	</div>

	<footer>
		<a href="https://www.onetag.com/">&copy; Onetag</a>
		|
		<a href="https://www.onetag.com/privacy-platform/">Privacy Policy</a>
	</footer>
</div>
